import { Key } from "shared/assets/icons";
import { copy } from "shared/assets";
import {
  Button,
  ClipboardField,
  FormBuilder,
  Message,
  Modal,
} from "shared/components";
import { IAPIError, IFieldType, IStatus, ITheme } from "shared/types";
import { useApiKey } from "../hooks/useApiKey";
import { Spacer } from "shared/layout";

export const GenerateApiKeyModal = ({
  setIsModalOpen,
}: {
  setIsModalOpen: (isModalOpen: boolean) => void;
}) => {
  const { createKey } = useApiKey();

  return (
    <Modal title={copy.apiKeys.generate.title} icon={Key}>
      {createKey.data && (
        <Spacer size="m">
          <Message status={IStatus.success}>
            {copy.apiKeys.generate.success.title}
          </Message>
          <p>
            {copy.apiKeys.generate.success.description.map((line, index) => (
              <span key={index}>
                {line}
                {index <
                  copy.apiKeys.generate.success.description.length - 1 && (
                  <br />
                )}
              </span>
            ))}
          </p>
          <ClipboardField
            label={copy.apiKeys.generate.success.fieldLabel}
            copyText={createKey.data?.attributes?.apiKey || ""}
          />
          <Button
            theme={ITheme.secondary}
            onClick={() => {
              setIsModalOpen(false);
              createKey.reset();
            }}
          >
            {copy.apiKeys.actions.close}
          </Button>
        </Spacer>
      )}

      {!createKey.data && (
        <Spacer size="m">
          <FormBuilder
            onSubmit={({ description }) => createKey.mutate(description)}
            isSubmitting={createKey.isPending}
            apiError={createKey.error as IAPIError | null}
            buttons={{
              primary: {
                children: copy.apiKeys.generate.button,
              },
              secondary: {
                children: copy.apiKeys.actions.close,
                onClick: () => setIsModalOpen(false),
              },
            }}
            fields={[
              {
                name: "description",
                label: copy.apiKeys.generate.form.description.label,
                type: IFieldType.text,
                validation: {
                  required: copy.apiKeys.generate.form.description.required,
                },
              },
            ]}
          />
          <Message status={IStatus.warning}>
            {copy.apiKeys.generate.warning}
          </Message>
        </Spacer>
      )}
    </Modal>
  );
};
